import { useI18n } from 'vue-i18n';
import { useModals } from '@common';
import { useHtmlContent } from '@shared';

export const useInfoModal = (htmlKey = '', title = '') => {
  const { htmlContent, loadHtmlContent } = useHtmlContent({ key: htmlKey });
  const modals = useModals();
  const { t } = useI18n();

  const openInfoModal = async (overrideKey?: string) => {
    const key = typeof overrideKey === 'string' && overrideKey ? overrideKey : htmlKey;
    await loadHtmlContent(key);
    modals.openDialog({
      title: title ? t(title) : '',
      text: htmlContent.value?.html,
      translate: false,
      width: '800px',
      scrollable: true
    });
  };

  return {
    openInfoModal,
    loadHtmlContent
  };
};
